import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { BellOutlined, ClockCircleOutlined, LockOutlined, StarOutlined } from '@ant-design/icons';
// eslint-disable-next-line import/no-unresolved
import alarm from '@design-system/assets/browsingCard/tag/alarm.svg';
import Image from "next/legacy/image";
import Tag, { TagProps } from './Tag';

const StyledStatusTagWrapper = styled.div`
  position: absolute;
  top: 11px;
  left: 13px;
`;

const StyledSoldOverlay = styled.div<{ isSold: boolean }>`
  ${(props) =>
    props.isSold &&
    css`
      position: absolute;
      inset: 0;
      background-color: rgba(0, 0, 0, 0.5);
      border-top-right-radius: 12px;
      border-top-left-radius: 12px;
      z-index: 3;
      -webkit-transform: translate3d(0, 0, 0);
    `}
`;

export interface StatusTagProps extends Omit<TagProps, 'labelColor'> {
  status: string;
}

type TagConfigProps = {
  textColor: string;
  backgroundColor: string;
  tLabel: string;
  icon?: React.ReactNode;
};

const TagConfig: Record<StatusTagProps['status'], TagConfigProps> = {
  newArrival: {
    textColor: '#FF4C00',
    backgroundColor: '#FFEDE5',
    tLabel: 'shared.listingCard.newArrival',
    icon: <StarOutlined />,
  },
  pendingSale: {
    textColor: '#FFFFFF',
    backgroundColor: '#383839',
    tLabel: 'shared.listingCard.pendingSale',
    icon: <Image className="anticon" src={alarm} />,
  },
  comingSoon: {
    textColor: '#FF4C00',
    backgroundColor: '#FFEDE5',
    tLabel: 'shared.listingCard.comingSoon',
    icon: <ClockCircleOutlined />,
  },
  sold: {
    textColor: '#222223',
    backgroundColor: '#D3D3D3',
    tLabel: 'shared.listingCard.sold',
    icon: <LockOutlined />,
  },
  notifyMe: {
    textColor: '#FFFFFF',
    backgroundColor: '#FF4C00',
    tLabel: 'shared.listingCard.notifyMe',
    icon: <BellOutlined />,
  },
};

const StatusTag: FC<StatusTagProps> = (props) => {
  const { t } = useTranslation();

  const { status, onClick } = props;
  const { textColor, backgroundColor, tLabel, icon } = TagConfig[status];

  return (
    <Tag color={backgroundColor} icon={icon} labelColor={textColor} onClick={onClick}>
      <span className="label">{t(tLabel)}</span>
    </Tag>
  );
};

const StatusTagWrapper: FC<StatusTagProps> = (props) => {
  const { status } = props;
  const isSold = status === 'sold';

  return (
    <StyledSoldOverlay isSold={isSold}>
      <StyledStatusTagWrapper>
        <StatusTag {...props} />
      </StyledStatusTagWrapper>
    </StyledSoldOverlay>
  );
};
export { StatusTagWrapper };
export default StatusTag;
